export default __webpack_public_path__ + "static/media/gke.ff2c73bc.svg";